import { FC } from 'react';

import { ContentfulProvider } from '../ContentfulProvider/ContentfulProvider';
import { StyledContainer, StyledSkeleton } from './ContentSlot.styles';
import { ContentSlotBase } from './ContentSlotBase';
import { useContentSlotQuery } from './useContentSlotQuery';

type Props = {
    identifier: string;
};

export const ContentSlot: FC<Props> = ({ identifier }) => {
    const { data, isLoading } = useContentSlotQuery(identifier);

    if (isLoading) {
        return (
            <StyledContainer>
                <StyledSkeleton />
            </StyledContainer>
        );
    }

    if (!data) {
        return null;
    }

    return (
        <ContentfulProvider>
            <ContentSlotBase contentItem={data} />
        </ContentfulProvider>
    );
};
